/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { Helmet } from 'react-helmet';

import InnerHTML from 'dangerously-set-html-content';

import { IEshopCustomFaqViewProps } from './eshop-custom-faq';

export class EshopCustomFaqView extends React.PureComponent<IEshopCustomFaqViewProps> {
    public componentDidMount() {
        const script = document.createElement('script');

        script.src = 'https://cdn.jsdelivr.net/npm/jquery@3.5.1/dist/jquery.slim.min.js';
        script.integrity = 'sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj';
        script.crossOrigin = 'anonymous';

        document.body.appendChild(script);

        const bsScript = document.createElement('script');

        bsScript.src = 'https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/js/bootstrap.bundle.min.js';
        bsScript.integrity = 'sha384-Fy6S3B9q64WdZWQUiU+q4/2Lc9npb8tCaSX9FK7E8HnRr0Jz8D6OP9dO5Vg3Q9ct';
        bsScript.crossOrigin = 'anonymous';

        document.body.appendChild(bsScript);
    }

    public render(): JSX.Element | null {
        const { markup } = this.props;

        if (markup === '') {
            return null;
        }

        // Find scripts from html and execute in <Helmet></Helmet>.
        // eslint-disable-next-line security/detect-non-literal-regexp
        const scriptsRegExp = new RegExp(`<script.*?>.*?</script>`);
        const scripts = scriptsRegExp.exec(markup);

        return (
            <>
                {scripts?.map((script, index) => {
                    return (
                        <Helmet key={index} defer={false}>
                            {script}
                        </Helmet>
                    );
                })}

                <InnerHTML
                    html={markup}
                    className='ecomm-pdp'
                    id={this.props.config.descriptionAnchorTag ? this.props.config.descriptionAnchorTag : ''}
                />
            </>
        );
    }
}

export default EshopCustomFaqView;
